import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { IPalette, IThemeOptions } from 'theme/ITheme';
import themeCommon from 'theme/themeCommon';
import customPalette from './palette';

const palette: IPalette = {
  ...themeCommon.palette,
  ...customPalette,
  background: {
    ...themeCommon.palette.background,
    ...customPalette.background,
  },
};

const dialogOverrides = {
  MuiDialog: {
    root: {
      position: 'absolute !important',
    },
    paperFullScreen: {
      height: '100%',
    },
  },
};

const overrides = { ...themeCommon.overrides, ...dialogOverrides };

const geotabTheme = createMuiTheme({
  ...themeCommon,
  palette,
  overrides,
} as IThemeOptions);

export default geotabTheme;
